import { FC, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useGameDataContext } from "@context/GameDataContext";
import {
  ContentMap,
  getContent,
  renderGameResult,
  renderGameStart,
  renderSetBreak,
  renderSubstitution,
  renderTimeout,
} from "./statusMessageContent";
import { gameState, useTeamSides } from "@/services/gameState";
import { useAppDataContext } from "@context/AppContext";

const contentMap: ContentMap = {
  gameStart: { priority: 1, potentialRender: renderGameStart },
  timeout: { priority: 2, potentialRender: renderTimeout },
  setBreak: { priority: 3, potentialRender: renderSetBreak },
  substitution: { priority: 5, potentialRender: renderSubstitution },
  gameWon: { priority: 100, potentialRender: renderGameResult },
};

const RefereeTabletStatusMessage: FC = () => {
  const { game } = useGameDataContext();

  const currentSet = gameState("currentSet");
  const currentScore = gameState("currentScore");
  const gameProgress = gameState("gameProgress");
  const teamSquads = gameState("teamSquads");
  const teams = gameState("teams");
  const lastTimeout = gameState("lastTimeout");
  const serving = gameState("serving");
  const isSetPauseOngoing = gameState("isSetPauseOngoing");
  const expectedNextSetStartTime = gameState("expectedNextSetStartTime");
  const startTime = gameState("startTime");
  const lastAction = gameState("lastAction");
  const substitutions = gameState("substitutions");
  const { leftTeam, rightTeam } = useTeamSides(useAppDataContext());

  const [currentTimestamp, setCurrentTimestamp] = useState<number>(Date.now());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTimestamp(Date.now());
    }, 100);
    return () => {
      clearInterval(timer);
    };
  }, [game]);

  return (
    <Box
      sx={{
        align: "center",
        flexShrink: 0,
        fontSize: "5vw",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        height: "6vw",
        lineHeight: "6vw",
        maxHeight: "7vw",
        textAlign: "center",
      }}
    >
      {getContent({
        contentMap,
        currentTimestamp,
        currentSet,
        currentScore,
        lastAction,
        lastTimeout,
        serving,
        teamSquads,
        teams,
        gameProgress,
        isSetPauseOngoing,
        expectedNextSetStartTime,
        startTime,
        leftTeam,
        rightTeam,
        substitutions,
      })}
    </Box>
  );
};

export default RefereeTabletStatusMessage;
